/*
  In a case, then buckets listing is restricted, some storage providers can return empty buckets list,
  but other can return exception
*/
export enum BucketsListingRestrictedPossibility {
  Maybe = 'maybe',
  Exactly = 'exactly'
}

export const BucketNameValidator = {
  S3: /^(?!\d+\.\d+\.\d+\.\d+$)(?!.*\.\.)(?!.*\.-)(?!.*-\.)([a-z0-9][a-z0-9.-]*[a-z0-9])$/,
  // Same as S3, but the backend prefixes UB AWS bucket names, so a single character is allowed
  UbAws: /^(?!\d+\.\d+\.\d+\.\d+$)(?!.*\.\.)(?!.*\.-)(?!.*-\.)([a-z0-9]([a-z0-9.-]*[a-z0-9])?)$/,
  Google: /^(?!.*g[o0]+g)(?!\d+\.\d+\.\d+\.\d+$)(?!.*\.\.)([a-z0-9]([a-z0-9-_]{0,61}[a-z0-9])?)(\.[a-z0-9]([a-z0-9-_]{0,61}[a-z0-9])?)*$/,
  Azure: /^(?!.*--)[a-z0-9]+(-[a-z0-9]+)*$/,
  B2: /^(?!b2-)[a-zA-Z0-9]+[-a-zA-Z0-9]*$/,
  Wasabi: /^(?!\d+\.\d+\.\d+\.\d+$)(?!.*\.\.)(?!.*\.-)(?!.*-\.)([a-z0-9][a-z0-9.-]*[a-z0-9])$/,
  ImpossibleCloud: /^(?!.*--)[a-z0-9][a-z0-9-]*[a-z0-9]$/
};

export const e2eLocators = {
  displayNameControl: 'display-name-control',
  createNewBtn: 'create-new-btn',
  existingBucketBtn: 'existing-bucket-btn',
  bucketNameControl: 'bucket-name-control',
  storageClassControl: 'storage-class-control',
  regionControl: 'region-control',
  googleDestinationSubregionControl: 'google-destination-subregion-control',
  isExternalBucketControl: 'is-external-bucket-control',
  objectLockTitle: 'object-lock-title',
  defaultOLControl: 'default-ol-control',
  objectLockPeriodDaysControl: 'object-lock-period-days-control',
  isGfsObjectLockEnabledControl: 'is-gfs-object-lock-enabled-control',
  immutabilityNotChange: 'immutability-not-change',
  s3AcceleratorControl: 's3-accelerator-control',
  reuseAccountRulesControl: 'reuse-account-rules-control',
  companiesControl: 'add-destination-companies-control',
  addNewCompanyBtn: 'add-destination-add-new-company-btn'
};
